import * as React from "react";
import { Helmet } from "react-helmet";
import { useStaticQuery } from "gatsby";
export function PageHeader(a) {
  var _useStaticQuery = useStaticQuery("1180902673"),
      b = _useStaticQuery.siteConfig,
      c = a.seo,
      d = b.stylesheets,
      e = b.scripts,
      f = b.social,
      g = b.seo,
      h = (c === null || c === void 0 ? void 0 : c.title) || g.title,
      i = (c === null || c === void 0 ? void 0 : c.description) || g.description,
      j = (c === null || c === void 0 ? void 0 : c.image) || g.image,
      k = (c === null || c === void 0 ? void 0 : c.keywords) || g.keywords,
      l = {
    lang: (c === null || c === void 0 ? void 0 : c.lang) || g.lang
  },
      m = (c === null || c === void 0 ? void 0 : c.jsonLd) || g.jsonLd;

  return /*#__PURE__*/React.createElement(Helmet, {
    defer: !1,
    htmlAttributes: l
  }, /*#__PURE__*/React.createElement("title", null, h), /*#__PURE__*/React.createElement("meta", {
    name: "title",
    content: h
  }), /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: i
  }), k && /*#__PURE__*/React.createElement("meta", {
    name: "keywords",
    content: k
  }) || null, /*#__PURE__*/React.createElement("meta", {
    property: "og:type",
    content: "website"
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:title",
    content: h
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:description",
    content: i
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:site_name",
    content: g.title
  }), j && /*#__PURE__*/React.createElement("meta", {
    property: "og:image",
    content: j
  }), /*#__PURE__*/React.createElement("meta", {
    name: "twitter:title",
    content: h
  }), /*#__PURE__*/React.createElement("meta", {
    name: "twitter:description",
    content: i
  }), f && f.twitter && /*#__PURE__*/React.createElement("meta", {
    name: "twitter:site",
    content: f.twitter
  }), /*#__PURE__*/React.createElement("meta", {
    name: "twitter:card",
    content: j ? "summary_large_image" : "summary"
  }), j && /*#__PURE__*/React.createElement("meta", {
    property: "twitter:image",
    content: j
  }), d.filter(function (a) {
    return !!a;
  }).map(function (a) {
    return /*#__PURE__*/React.createElement("link", {
      key: a,
      href: a,
      rel: "stylesheet"
    });
  }), e.filter(function (a) {
    return !!a;
  }).map(function (a) {
    return /*#__PURE__*/React.createElement("script", {
      key: a,
      src: a
    });
  }), m && /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(m)));
}